import Vue from "vue"

Vue.mixin({
    methods: {
        betslipOpener: (auth, store, checkId, eventID) => {
            // console.log(checkId, eventID)
            // console.log(
            //   store.state.placeBet.runner.id,
            //   store.state.placeBet.market._id
            // )
            if (!checkId) {
                return false
            } else if (!auth.loggedIn) {
                return false
            } else if (
                store.state.settings.userConfig &&
                store.state.settings.userConfig.oneClickStatus &&
                store.state.placeBet.bettingType === "default" &&
                checkId === store.state.placeBet.runner.betfairId &&
                eventID === store.state.placeBet.market.betfairId
            ) {
                return true
            } else if (
                store.state.placeBet.runner &&
                checkId === store.state.placeBet.runner.betfairId &&
                eventID === store.state.placeBet.market.betfairId
            ) {
                return true
            } else if (
                store.state.placeBet.runner &&
                checkId === store.state.placeBet.runner.id &&
                (eventID === store.state.placeBet?.market?._id ||
                    eventID === store.state.placeBet?.market?.marketId)
            ) {
                return true
            } else if (
                store.state?.placeBet?.bettingType === "artemisFancy" &&
                store.state?.placeBet?.runner &&
                checkId === store.state?.placeBet?.runner?.marketId &&
                eventID === store.state?.placeBet?.market?.betfairId
            ) {
                return true
            }
            // else if (
            //   store.state.placeBet.runner &&
            //   checkId === store.state.placeBet.runner.id
            // ) {
            //   console.log(eventID)
            //   return true
            // }
            else {
                return false
            }
        },
        nonBetFairBetSlipOpener: (auth, store, checkId, eventID) => {
            if (!checkId) {
                return false
            } else if (!auth.loggedIn) {
                return false
            } else if (
                store.state.settings.userConfig &&
                store.state.settings.userConfig.oneClickStatus &&
                store.state.placeBet.bettingType === "default" &&
                checkId === store.state.placeBet.runner.id &&
                eventID === store.state.placeBet.market.eventId
            ) {
                return true
            } else if (
                store.state.placeBet.runner &&
                checkId === store.state.placeBet.runner.id &&
                eventID === store.state.placeBet.market.eventId
            ) {
                return true
            } else if (
                store.state.placeBet.runner &&
                checkId === store.state.placeBet.runner.id &&
                eventID === store.state.placeBet.market._id
            ) {
                return true
            } else {
                return false
            }
        }
    }
})
